import { createTheme } from "@mui/material/styles";

// Public site theme - dark, industrial, brand red used sparingly
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#AA3737",
      contrastText: "#fff",
    },
    secondary: {
      main: "#f2f0ed",
      contrastText: "#0c0c0c",
    },
    background: {
      default: "#0c0c0c",
      paper: "#161616",
    },
    text: {
      primary: "#f2f0ed",
      secondary: "#a3a3a3",
    },
  },
  shape: {
    borderRadius: 0,
  },
  typography: {
    fontFamily: "Montserrat, Arial, sans-serif",
    button: {
      fontWeight: 800,
      letterSpacing: "0.12em",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: "14px 28px",
        },
        sizeLarge: {
          padding: "18px 36px",
          fontSize: "0.95rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255, 255, 255, 0.03)",
        },
        notchedOutline: {
          borderColor: "rgba(255, 255, 255, 0.28)",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#111",
          backgroundImage: "none",
        },
      },
    },
  },
});

export default theme;
